import { Icon } from 'ui/atoms/Icon/Icon';

interface Props {
  hasBackground?: boolean;
  className?: string;
}

const logos = [
  { icon: 'uber', width: '89', height: '32' },
  { icon: 'sap', width: '69', height: '34' },
  { icon: 'aws', width: '64', height: '40' },
  { icon: 'lseg', width: '160', height: '50' },
  { icon: 'economist', width: '142', height: '43' },
  { icon: 'jp-morgan', width: '200', height: '50' },
];

export const OurCustomers = ({ hasBackground = true, className = '' }: Props) => {
  return (
    <div className={`customer-block-clients${hasBackground ? ' has-background' : ''} ${className}`}>
      {logos.map((item, idx) => (
        <Icon
          key={idx}
          url={`/storage/svg/customers/${item.icon}.svg`}
          style={{ width: item.width, height: item.height }}
        />
      ))}
    </div>
  );
};
